import {Component, OnInit} from '@angular/core';
import {RequeteService, RequeteStatut, RequeteSummary} from '../../entities/requete';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DossierModalComponent} from './dossier-modal-component';
import {DisplayedColumn, RequetesDataSource, RequeteStatutFilter} from './mes-dossiers.datasource';
import {TrackingAction, TrackingCategory} from '../../shared/model/tracking/tracking.enum';
import {TrackingService} from '../../shared/services/tracking.service';

@Component({
    selector: 'jhi-mes-dossiers',
    templateUrl: './mes-dossiers.component.html',
    styleUrls: ['./mes-dossiers.component.scss']
})
export class MesDossiersComponent implements OnInit {

    dataSource$ = new RequetesDataSource();

    displayedColumns: Array<DisplayedColumn> = Object.keys(DisplayedColumn).map(key => DisplayedColumn[key]);

    statutFilter: RequeteStatutFilter;

    sortKey: DisplayedColumn;

    isLoading: boolean;

    isError: boolean;

    constructor(
        private router: Router,
        private modalService: NgbModal,
        private requeteService: RequeteService,
        private trackingService: TrackingService
    ) {
    }

    ngOnInit() {
        this.sortKey = this.dataSource$.sortKey$.getValue();
        this.statutFilter = this.dataSource$.statutFilter$.getValue();
        this.populateRequeteList();
    }

    openRequete( requete: RequeteSummary) {
        if ((requete.statut === RequeteStatut.EN_ATTENTE_DE_RATTACHEMENT)) {
            const modalRef = this.modalService.open(DossierModalComponent, {size: 'lg'});
            modalRef.componentInstance.requete = requete;
        } else {
            this.requeteService.clear();
            this.router.navigateByUrl(`/historique/${requete.id}`);
        }
    }

    addDocument( requete: RequeteSummary) {
        this.router.navigateByUrl(`/historique/${requete.id}/document`);
    }

    adjustSort(key: string) {
        this.dataSource$.adjustSort(key);
    }

    applyFilter(key: string) {
        this._track(TrackingAction.CLIQUER, `Filtre : ${key}`);
        this.dataSource$.applyFilter(key);
    }

    displayAddDocumentBtn(requete: RequeteSummary): boolean {
        return this.requeteService.canAddPieces(requete);
    }

    private populateRequeteList() {
        this.isLoading = true;
        this.requeteService.getAll()
        .subscribe(requetes => {
            this.dataSource$.init(requetes);
            this.isLoading = false;
        }, _err => {
            this.isLoading = false;
            this.isError = true;
        });
    }

    private _track(action: TrackingAction, name: string) {
      this.trackingService.trackEvent({
        action,
        properties: {
          category: TrackingCategory.MES_DOSSIER,
          name: name
        }
      });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/mes-dossiers/mes-dossiers.component.ts